import { render, staticRenderFns } from "./compare-bar.vue?vue&type=template&id=f032c3e2"
import script from "./compare-bar.vue?vue&type=script&lang=js"
export * from "./compare-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports